export default __webpack_public_path__ + "static/media/Hand-wraps of the Faceless Chaos.69fef611.jpg";